// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').directive('giFadeScroll', ($document) => ({
  restrict: 'A',

  link(scope, element, attrs) {
    const fadeScroll = function () {
      const scrollTop = $(window).scrollTop() - element.offset().top;
      const height = element.height();
      const css = { opacity: (height - scrollTop) / height };
      element.css(css);
      return true;
    };

    return $document.on('scroll', fadeScroll);
  },
}));
